import { SectionHead } from "./SectionHead";
import { IMAGES } from "@/lib/product";
import { ProductVideo } from "./ProductVideo";

const STEPS = [
  ["01", "Posez le kit fenêtre", "Fixez le support de fenêtre fourni, sans perçage. Il s'adapte à la plupart des fenêtres et portes-fenêtres à battants. Un support toit est disponible en option."],
  ["02", "Accrochez l'unité extérieure", "Installez l'unité extérieure compacte (9,9 kg) sur son support, faites passer la liaison préassemblée et refermez la fenêtre sur le joint d'étanchéité."],
  ["03", "Branchez et profitez", "Branchez sur une prise classique et lancez l'appareil avec la télécommande ou l'app Midea SmartHome. Aucune manipulation de fluide frigorigène."],
];

export const Installation = () => (
  <section id="installation" data-testid="installation-section" className="section section-dark">
    <div className="container-x grid lg:grid-cols-[1fr_0.9fr] gap-14 items-center">
      <div>
        <SectionHead eyebrow="Comment ça marche" title="Installé en 10 minutes. Sans technicien." text="Pas de rendez-vous, pas de carottage, pas de frigoriste : vous installez votre climatisation vous-même, et vous la démontez aussi facilement." light />
        <ol className="mt-12 flex flex-col gap-4">
          {STEPS.map(([n, title, desc], i) => (
            <li key={n} data-testid={`step-${i + 1}-card`} className="step-card">
              <span className="font-mono text-sm font-semibold text-sky-300">{n}</span>
              <div>
                <h3 className="font-display text-lg sm:text-xl font-bold text-white">{title}</h3>
                <p className="text-sky-100/75 leading-relaxed mt-1.5 text-[15px]">{desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
      <div className="flex flex-col gap-4">
        <div data-testid="install-main-image" className="relative rounded-3xl overflow-hidden aspect-[650/506] ring-1 ring-white/10">
          <img src={IMAGES.hoseWindow} alt="Unité intérieure reliée par sa liaison à l'unité extérieure placée derrière la fenêtre" className="w-full h-full object-cover" loading="lazy" />
          <div className="glass-dark absolute left-4 bottom-4 sm:w-72">
            <span className="text-xs uppercase tracking-[0.16em] text-sky-300">Inclus dans le carton</span>
            <p className="text-white text-sm mt-1.5">Kit fenêtre, liaison préassemblée, télécommande.</p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {[[IMAGES.outdoorWindow, "Unité extérieure sur fenêtre", "install-outdoor-image"], [IMAGES.bracket, "Support fenêtre inclus", "install-bracket-image"]].map(([src, label, id]) => (
            <figure key={id} data-testid={id} className="flex flex-col gap-2">
              <div className="rounded-2xl overflow-hidden aspect-square ring-1 ring-white/10 bg-white">
                <img src={src} alt={label} className="w-full h-full object-cover" loading="lazy" />
              </div>
              <figcaption className="text-xs font-semibold uppercase tracking-[0.14em] text-sky-200">{label}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </div>
    <div className="container-x">
      <ProductVideo />
    </div>
  </section>
);
